import React from 'react'
import { useFeatureValue } from '@news-mono/web-common'
import { ElectionTitle, StyledElectionTitleContainer } from '../components'
import { SeatData, getInterknowledgyData, getSeatsData } from '../data'
import { SeatCard } from '../SeatCard/SeatCard'
import { TheSeatEmbedWidget } from '../TheSeatEmbedWidget/TheSeatEmbedWidget'

/**
 * @returns a collection component to display all electorate embeds in one list
 */
export const TheSeatEmbedCollectionWidget = () => {
    const electionId: number = useFeatureValue('2025-election-id') || 632

    // get the seat data for the provided electrorate name
    const [seatData, setSeatData] = React.useState<SeatData[] | undefined>()
    const [isLoading, setIsLoading] = React.useState<boolean>(true)

    React.useEffect(() => {
        const load = async () => {
            let data

            try {
                data = await getInterknowledgyData(electionId)
                const seats = getSeatsData(data)
                setSeatData(seats)
            } catch (error) {
                console.error('Error loading interknowlogy data:', error)
            }
        }

        if (isLoading) {
            load()
            setIsLoading(false)
        }
    }, [electionId, isLoading])

    return (
        <>
            <StyledElectionTitleContainer>
                <ElectionTitle>The Seat Embeds</ElectionTitle>
            </StyledElectionTitleContainer>
            {seatData
                ? seatData
                      .slice(0, 10)
                      .map((seat) => (
                          <TheSeatEmbedWidget
                              key={seat.seatId}
                              providedData={seat}
                          />
                      ))
                : Array(5) // Render 5 skeletons while loading
                      .fill(0)
                      .map((_, index) => (
                          <SeatCard key={index} isLoading isEmbed={true} />
                      ))}
        </>
    )
}
